// 数据保留策略「保留天数」合法性校验（纯函数，便于单测）。
// 下限来自后端白名单枚举 RetainableTable.minRetentionDays（每张表各不相同），
// 前端拦截只是体验优化，真正兜底在后端 coerceAtLeast。

export function validateRetentionDays(
  value: number | null | undefined,
  minRetentionDays: number | null | undefined
): string | null {
  if (value == null) {
    return null;
  }
  if (minRetentionDays != null && value < minRetentionDays) {
    return `该表的保留天数不能低于 ${minRetentionDays} 天`;
  }
  return null;
}
